import React from 'react';

import { Field, ErrorMessage } from 'formik';

import InputErrorMessage from '@components/common/Formik/InputErrorMessage/InputErrorMessage';
import Switch from '@components/common/Switch/Switch';

type FormikSwitchProps = {
    name: string;
    customClass?: string;
    children?: any;
    defaultOn: boolean;
    onSwitchChange?: (value: boolean) => void;
    customStyle?: any;
};

const FormikSwitch: React.FC<FormikSwitchProps> = ({
    name,
    customClass,
    defaultOn,
    onSwitchChange,
    children,
    ...props
}: FormikSwitchProps) => {
    return (
        <div className={customClass || ''}>
            <Field name={name}>
                {({ field, form }) => {
                    const handleChange = (value: boolean) => {
                        form.setFieldValue(name, value);
                        if (onSwitchChange) {
                            onSwitchChange(value);
                        }
                    };

                    return (
                        <Switch
                            {...props}
                            customClass={customClass}
                            defaultOn={field.value ?? defaultOn}
                            onChange={handleChange}
                        >
                            {children}
                        </Switch>
                    );
                }}
            </Field>
            <ErrorMessage name={name} render={(msg) => <InputErrorMessage name={name} messageCode={msg} />} />
        </div>
    );
};

export default FormikSwitch;
